import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div>
        <h1>Link Not Found</h1>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js